import { InformationCircleIcon } from '@heroicons/react/20/solid';

type ScannedTotalsBannerProps = {
    onReview: () => void;
};

export function ScannedTotalsBanner({ onReview }: ScannedTotalsBannerProps) {
    return (
        <div className="flex items-center gap-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-[12.5px] text-amber-900">
            <InformationCircleIcon className="h-4 w-4 shrink-0 text-amber-500" aria-hidden="true" />
            <p className="min-w-0 flex-1">
                We hebben totaalbedragen gescand voor sommige regels. Controleer ze als je ze wilt gebruiken.
            </p>
            <button
                type="button"
                onClick={onReview}
                className="shrink-0 whitespace-nowrap rounded font-medium text-amber-800 underline underline-offset-2 hover:text-amber-950 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400"
            >
                Totaal als netto toepassen
            </button>
        </div>
    );
}
